$(function() {
	$(document).on("click", ".choice", function() {
		var radioInput = $(this).find("input[type='radio']");
		radioInput.prop("checked", true);
		radioInput
			.closest("form")
			.find("input[type='radio'][name='" + radioInput.attr("name") + "']")
			.trigger("change");
	});
});
